import * as React from 'react';
import Box from '@mui/material/Box';
import * as Features from '../../../../../../../shared/Features';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ImageEditorCommentsSectionSkeleton } from '../../comments/view/ImageEditorCommentsSection';
import { ImageListTabsSkeleton } from '../../listImages/view/ImageListTabs';

type ImageEditorImageProcessingPageSkeletonProps = {
    user: AuthenticatedUser;
};

export function ImageEditorImageProcessingPageSkeleton({
    user
}: ImageEditorImageProcessingPageSkeletonProps) {
    return (
        <Box
            component="section"
            aria-busy="true"
            aria-label={Translate('view-order/tab/image-processing/legend/image-processing')}
            sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
        >
            <ImageEditorCommentsSectionSkeleton user={user} />
            <ImageListTabsSkeleton
                showUneditedImages={Features.hasFeature(Features.ViewUneditedImages, user)}
            />
        </Box>
    );
}
